import React from 'react';
import queryString from 'query-string';
import PrivateRoute from 'PrivateRoutes';
import { Tag } from './components';

const moduleList = ({ location }) => {
  const queryParams = queryString.parse(location.search);
  console.log('queryParams', queryParams);
  return <Tag moduleId={queryParams.id} />;
};

const routes = () => (
  <PrivateRoute exact path="/settings/Tag" component={moduleList} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/Tag/routes.js